<template>
  <div v-if="alwaysShow || (price && price.amountWaitFee > 0)">
    <van-submit-bar
      ref="paySubmitBar"
      :price="formatPrice"
      button-text="立即支付"
      class="order-submit-bar"
      @submit="onSubmit()"
    ></van-submit-bar>
    <van-actionsheet
      :close-on-click-overlay="false"
      class="sby-paying"
      get-container=".page-wrap"
      v-model="showPay"
      :title="isWechatPay ? '支付' : '请使用手机银行自主转账'"
      @cancel="onCancel"
    >
    <van-row class="center" style="padding-bottom:0;">
        <span
          v-if="isWechatPay"
          class="price"
          @click="copy($event, price.amountWaitFee) "
        >
        <span>￥</span>{{isWechatPay ? price.weixin.amountWaitFee : price.amountWaitFee}}</span>
        <!--
        <div class="copy-tips" v-if="isBankPay">为避免转错，转账前请
          <van-tag type="success">点击复制</van-tag>金额、账号、户名和开户行
        </div>
        -->
      </van-row>
      <van-cell title="支付方式" is-link @click="switchPayMethod()">
        <template v-slot>
          <div v-if="isWechatPay">
            <img src="../assets/images/wechat.png" alt="" class="icon">微信支付
          </div>
          <div v-else-if="isBankPay">
            <img src="../assets/images/bank.png" alt="" class="icon">转到银行卡
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>
    <van-steps :active="100" direction="vertical" v-if="isBankPay">
     <van-step>
      <span class="step-title" @click="copy($event, price.amountWaitFee) ">① 请向下面收款账户转账：<span class="amount-fee">{{price.amountWaitFee}}</span>元</span>
      <div v-if="bankAccount.name" style="background-color: #f6f6f6; border-radius: 10px; margin-top: 12px;">
          <div
            class="sby-panel-item"
            style="padding-top: 5px;"
            @click="copy($event, bankAccount.name)">
            <div class="van-cell__title">
              <span>收款户名</span>
            </div>
            <div class="van-cell__value">
              <span>{{bankAccount.name}}</span>
            </div>
          </div>
          <div class="sby-panel-item" @click="copy($event, bankAccount.cardid)">
            <div class="van-cell__title">
              <span>收款账号</span>
            </div>
            <div class="van-cell__value">
              <span>{{bankAccount.cardid}}</span>
            </div>
          </div>
          <div class="sby-panel-item" @click="copy($event, bankAccount.bankname)">
            <div class="van-cell__title">
              <span>收款银行</span>
            </div>
            <div class="van-cell__value">
              <span>{{bankAccount.bankname}}</span>
            </div>
          </div>
        </div>
        <div v-if="bankAccount.name" style="background-color: #f6f6f6; border-radius: 10px; margin-top: 12px;">
          <div
            class="sby-panel-item"
            style="padding-top: 5px;"
            @click="copy($event, bankAccount.name)">
            <div class="van-cell__title">
              <span>收款户名</span>
            </div>
            <div class="van-cell__value">
              <span>{{bankAccount.name}}</span>
            </div>
          </div>
          <div class="sby-panel-item" @click="copy($event, '6217000010007135000')">
            <div class="van-cell__title">
              <span>收款账号</span>
            </div>
            <div class="van-cell__value">
              <span>6217000010007135000</span>
            </div>
          </div>
          <div class="sby-panel-item" @click="copy($event, '建设银行')">
            <div class="van-cell__title">
              <span>收款银行</span>
            </div>
            <div class="van-cell__value">
              <span>建设银行</span>
            </div>
          </div>
        </div>
        <div>
          <ul style="list-style: disc; margin-left: 14px; margin-top: 10px; color: #747373;"><li>以上金额、账号、户名、开户行均可<van-tag type="success">点击复制</van-tag></li></ul>
        </div>
     </van-step>
     <van-step>
      <div class="step-title">② 转账完成后，请上传凭证并提交</div>
   <van-collapse v-model="activeNames" :border="true">
     <van-collapse-item name="1" disabled :border="false" :is-link="false">
       <sby-uploader
         v-on:upload="certImages = $event"
         :single="false"
         :withTip="false"
         :withBorder="false"
         v-if="showPay"
       ></sby-uploader>
     </van-collapse-item>
   </van-collapse>
   <van-field @blur="clearScroll()" v-model="remark" label="付款人姓名" placeholder="（他人代付时填写）"/>
     </van-step>
    </van-steps>

     
      
      <van-cell title="手续费" v-if="isWechatPay" label="微信收取 0.6% 手续费">+ {{price.weixin.chargeFee}} 元</van-cell>
      <!--
      <template v-if="isBankPay">
       
        <template v-if="bankAccount.name">
              <div
                class="sby-panel-item"
                style="padding-top: 5px;"
                @click="copy($event, bankAccount.name)"
              >
                <div class="van-cell__title">
                  <span>收款户名</span>
                </div>
                <div class="van-cell__value">
                  <span>{{bankAccount.name}}</span>
                </div>
              </div>
              <div class="sby-panel-item" @click="copy($event, bankAccount.cardid)">
                <div class="van-cell__title">
                  <span>收款账号</span>
                </div>
                <div class="van-cell__value">
                  <span>{{bankAccount.cardid}}</span>
                </div>
              </div>
              <div class="sby-panel-item" @click="copy($event, bankAccount.bankname)">
                <div class="van-cell__title">
                  <span>收款银行</span>
                </div>
                <div class="van-cell__value">
                  <span>{{bankAccount.bankname}}</span>
                </div>
              </div>
            </template> 
        <van-collapse v-model="activeNames" :border="true">
          <van-collapse-item name="1" disabled :border="false" :is-link="false">
            <div slot="title">
              上传转账凭证
              <span style="font-size:12px;">（适用有重名、他人代付、支付宝转账）</span>
            </div>
            <sby-uploader
              v-on:upload="certImages = $event"
              :single="false"
              :withTip="false"
              :withBorder="false"
              v-if="showPay"
            ></sby-uploader>
          </van-collapse-item>
        </van-collapse>
        <van-field @blur="clearScroll()" v-model="remark" label="付款人姓名" placeholder="（他人代付时填写）"/>
      </template>
            -->
      <van-row class="center">
        <van-button
          type="next"
          native-type="button"
          class="action"
          @click="submitPay()"
        >{{payBtnText}}</van-button>
      </van-row>
    </van-actionsheet>
    <van-actionsheet
      v-model="showSwitchPayMethod"
      title="请选择支付方式"
      @cancel="showSwitchPayMethod=false;showPay=true;"
    >
      <div
        class="order-card margin-top-20"
        clickable
        @click="changePayMethod('wechat')"
        v-if="!price.bankFail"
      >
        <van-cell class="pay-method-item">
          <template slot="title">
            <div class="order-title-box">
              <img src="../assets/images/wechat.png" alt="" class="icon">
              <span>微信支付
                <van-tag plain type="success">手续费 0.60%</van-tag>
              </span>
            </div>
          </template>
          <i class="van-icon van-cell__right-icon van-icon-arrow"></i>
        </van-cell>
        <span class="tips">自动审核，实时反馈；微信另收取0.6%手续费。</span>
      </div>
      <div class="order-card margin-bottom-20" clickable @click="changePayMethod('bank')">
        <van-cell class="pay-method-item">
          <template slot="title">
            <div class="order-title-box">
              <img src="../assets/images/bank.png" alt="" class="icon">
              <span>转到银行卡（仅提供收款账户）</span>
            </div>
          </template>
          <i class="van-icon van-cell__right-icon van-icon-arrow"></i>
        </van-cell>
        <span class="tips">人工审核，1-2个工作日反馈；
          <br>不具备实际转账功能，仅提供官方指定收款账户信息；手机银行或网银自主转账，再上传凭证，填写付款人。
        </span>
      </div>
    </van-actionsheet>
  </div>
</template>


<script>
import _ from "lodash";
import moment from "moment";
import {
  Toast,
  Actionsheet,
  Icon,
  Row,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Tabs,
  Tab,
  Button,
  Popup,
  Notify,
  Uploader,
  Field,
  Step, Steps
} from "vant";
import Vue from "vue";

Vue.use(Toast);
Vue.use(Actionsheet);
Vue.use(Row);
Vue.use(Button).use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Collapse);
Vue.use(Field).use(Notify);
Vue.use(CollapseItem).use(Uploader);
Vue.use(Tab).use(Tabs);
Vue.use(Step).use(Steps);

export default {
  name: "sby-paying",
  props: {
    price: {
      type: Object
    },
    billIds: {
      type: Array
    },
    show: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
    },
    alwaysShow: {
      type: Boolean,
      default: false
    },
    bottomHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showPay: false,
      paymentChannel: "",
      showSwitchPayMethod: false,
      certImages: [],
      remark: "",
      activeNames: ["1"],
      bankAccounts: {},
      bankAcctType: "default",
      bankAcctTypeIndex: 0,
      bank_type_list: [],
      isSubmiting: false,

      // 当前窗口的微信支付凭证
      transno: ""
    };
  },
  computed: {
    formatPrice() {
      if (_.isEmpty(this.price)) {
        return 0;
      }
      return parseFloat(this.price.amountWaitFee) * 100;
    },
    bankAccount() {
      if (this.bankAcctType) {
        return this.bankAccounts[this.bankAcctType];
      } else {
        return {
          bankname: "",
          name: "",
          cardid: ""
        };
      }
    },
    payBtnText() {
      return this.isWechatPay
        ? "确认付款"
        : this.isBankPay
          ? "我已转账，提交客服审核"
          : "请选择支付方式";
    },
    isWechatPay() {
      return this.paymentChannel === "wechat";
    },
    isBankPay() {
      return this.paymentChannel === "bank";
    }
  },
  mounted() {
    this.$http.get("/api/common/bankAccounts").then(response => {
      if (response) {
        this.bankAccounts = response.data.data;
        this.bank_type_list = _.map(_.keys(this.bankAccounts), n => {
          return { name: this.bankAccounts[n].title, value: n };
        });
        this.initLastPaymentInfo();
      }
    });

    this.submitPay = _.throttle(this.onSubmitPay, 2000);
    // 说明是银行卡付款过
    if (this.price.bankFail) {
      this.paymentChannel = "bank";
    }
  },
  updated: function() {
    this.$nextTick(() => {
      if (this.$refs.paySubmitBar && this.$refs.paySubmitBar.style) {
        this.$refs.paySubmitBar.style.bottom = this.bottomHeight + "px";
      }
    });
  },

  watch: {
    show(val) {
      this.showPay = val;
    },
    billIds(val) {
    }
  },
  beforeDestroy() {
    //Notify.clear();
  },
  methods: {
    // 默认选择最后一次支付方式
    initLastPaymentInfo() {
      this.$http.get("/api/bill/lastPaymentInfo").then(response => {
        if (response && !_.isEmpty(response.data.data)) {
          let { paymentChannel, bankAccType, remark } = response.data.data;
          if (bankAccType === 'company' || bankAccType === 'alipay') {
            bankAccType = 'default';
          }
          this.paymentChannel = paymentChannel;
          if (bankAccType) {
             this.bankAcctType = bankAccType;
             this.remark = remark;
          }
          // if (bankAccType) {
          //   this.bankAcctType = bankAccType;
          //   this.remark = remark;
          //   Object.keys(this.bankAccounts).forEach((val, index) => {
          //     if (val === this.bankAcctType) {
          //       this.bankAcctTypeIndex = index;
          //     }
          //   });
          // }
        }
      });
    },
    onSubmit() {
      if (this.validate && !this.validate()) {
        return false;
      }
      this.$emit("show");
      this.showPay=true;
      this.showBankTips()
    },
    onSubmitPay() {
      if (!this.isWechatPay && !this.isBankPay) {
        return;
      }
      if (this.isSubmiting) {
        return;
      }
      this.isSubmiting = true;
      if (this.isBankPay) {
        this.submitBankPay();
      } else {
        this.submitWechatPay();
      }
    },
    selectBankAccount(index, title) {
      this.bankAcctType = this.bank_type_list[index].value;
    },
    submitBankPay() {
      if (!this.bankAcctType) {
        Toast("请选择转账方式");
        this.isSubmiting = false;
        return;
      }
      if (!this.certImages || this.certImages.length === 0) {
        Toast("请上传转账凭证");
        this.isSubmiting = false;
        return;
      }
      this.$http
        .post(
          "/api/pay/bankTransfer",
          {
            billIds: this.billIds,
            images: this.certImages,
            bankAcctType: this.bankAcctType,
            remark: this.remark,
            couponId: this.price.coupon ? this.price.coupon.id : null,
          },
          { loading: true }
        )
        .then(response => {
          this.$hideLoading();
          if (response) {
            this.certImages = [];
            Toast("已提交转账凭证，请等待审核");
            // Notify.clear();
            this.$emit("success");
            this.isSubmiting = false;
            this.showPay = false;
            
          }
        })
        .catch(err => {
          this.isSubmiting = false;
        });
    },
    submitWechatPay: function() {
      this.$wechat.getSignature(() => {
        this.$http
          .post("/api/wechat/pay", {
            billIds: this.billIds,
            body: `同城保账单支付`,
            transno: this.transno,
            couponId: this.price.coupon ? this.price.coupon.id : null,
          })
          .then(response => {
            if (response) {
              this.$hideLoading();
              let data = response.data.data;

              this.transno = data.transno;
              // console.log("支付返回的数据", data);
              let self = this;
              // this.debugcontent = JSON.stringify(data) + "\n 时间戳是: ";
              this.$wx.ready(() => {
                let payOptions = {
                  success: function(res) {
                    console.log("当前支付结果", res);
                    if (res.errMsg === "chooseWXPay:ok") {
                      Toast("支付成功");
                      // self.golist();
                      self.$emit("success");
                      return;
                      //window.location.reload()
                    } else {
                      Toast("支付失败");
                      self.golist();
                      // window.location.reload()
                    }
                  },
                  cancel: function() {
                    Toast("支付取消");
                    // window.location.reload()
                  },
                  error: function(res) {
                    Toast("支付失败");
                    // window.location.reload()
                  }
                };

                payOptions = _.extend({}, payOptions, data.payOptions);

                this.$wx.chooseWXPay(payOptions);
              });

              this.isSubmiting = false;
            }
          })
          .catch(err => {
            this.isSubmiting = false;
          });
      });
    },
    copy(event, text, tag) {
      if (this.isWechatPay) {
        return;
      }
      this.$copyText(text).then(
        e => {
          Toast(text + " 已复制");
          console.log(e);
        },
        e => {
          Toast("本环境不支持复制到剪切板，建议长按复制");
          console.error(e);
        }
      );
    },
    showBankTips() {
      // if (this.isBankPay) {
      //   Notify({
      //     message:
      //       "为避免转错，转账前点击金额、帐号、户名、开户行进行复制。",
      //     duration: 0,
      //     className: "sby-top-tips left"
      //   });
      // } else {
      //   Notify.clear();
      // }
    },
    changePayMethod(type) {
      this.paymentChannel = type;
      this.showSwitchPayMethod = false;
      this.showPay = true;
      this.showBankTips();
    },
    switchPayMethod() {
      this.showSwitchPayMethod = true;
      this.showPay = false;
      // Notify.clear();
    },
    // 解决ios下输入法bug
    clearScroll() {
      const currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      window.scrollTo(currentPosition, 0);
    },
    onCancel() {
      // Notify.clear();
      this.$emit("cancel");
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM");
    },
    golist() {
      this.$router.push({ name: "order-list" });
    }
  }
};
</script>
<style lang="less" scoped>
.sby-paying {
  max-height: 90%;
  .price {
    font-size: 26px;
    font-weight: 500;
  }
  .action {
    width: 75%;
  }
  .tips {
    padding: 15px;
    font-size: 14px;
    color: red;
  }
  .icon {
    width: 20px;
    vertical-align: middle;
    margin-right: 5px;
  }

  .sby-panel-item {
    .van-cell__value {
      span {
        //color: #FF5722;
        border-bottom: 1px dashed #0ba3d2;
      }
    }
    .van-cell__title {
      max-width: 100px;
    }
  }
}
.copy-tips {
  font-size: 12px;
  color: gray;
}

.center {
  text-align: center;
}
.van-row {
  padding-top: 10px;
  padding-bottom: 10px;
}
.order-box {
  margin-bottom: 20px;
}

.van-submit-bar__text {
  text-align: left;
  margin-left: 10px;
}

.step-title {
  color: #2f2c2c;
  font-size: 16px;
  .amount-fee {
    border-bottom: 1px dashed #0ba3d2; display: inline-block;font-weight: bold;color: #0ba3d2;
  }
}

.order-card {
  background-color: white;
  padding-bottom: 5px;
  margin-bottom: 15px;

  .van-cell__title {
    color: #424243;
  }
  .van-cell__value {
    flex: 0.3;
  }
  &:first {
    margin-top: 23px;
  }
  .pay-method-item {
    padding: 0px 15px;
    font-size: 14px;
    line-height: 8px;
  }
  .van-cell__label {
    margin-left: 22px;
    min-width: 260px;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
  span.tips {
    text-align: left;
    font-size: 12px;
    color: #9e9e9e;
    display: block;
    margin: 20px;
    margin-top: 0px;
    margin-bottom: 5px;
    margin-left: 43px;
  }
}
.order-title-box {
  .icon {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 5px;
  }
}


.van-step--vertical:first-child::before {
    width: 0px !important;
  }

  .van-step--vertical:not(:last-child)::after {
    border-bottom-width: 0px !important;
}

.van-hairline--top-bottom::after {
    border-width: 0 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sby-paying.vue